import React from "react";
import styles from "./styles.css";
function PreviewScreenshots({ items }) {
    return (React.createElement("section", { className: styles.container },
        React.createElement("ul", { className: styles.previewContainer }, items.map((item) => {
            return (React.createElement("li", { key: item.src },
                React.createElement("img", { src: item.src, alt: item.alt })));
        }))));
}
export default PreviewScreenshots;
